var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesLogo3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 396.644,
    height: 82,
    viewBox: "0 0 396.644 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 182791",
    transform: "translate(-260.356 -8071)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD569\\uCE58\\uAE30 231",
    d: "M313.292 80h-16.664V.011h63.326v13.331h-46.662v20h43.327v13.329h-43.327v20h49.993V80zm-53.327 0V20.008l-26.663 20v-20l-26.663 20v-20L233.3.011v20l26.663-20h16.665V80zm-119.983 0-16-26.663H103.32V80H86.655V.011h39.995a26.656 26.656 0 0 1 12.2 50.36L156.647 80zM103.32 36.672h23.33a10 10 0 1 0 0-20h-23.33zM0 80V.011h39.995a26.663 26.663 0 1 1 0 53.325h-23.33V80zm16.665-43.328h23.33a10 10 0 1 0 0-20h-23.33zm156.972 43V0h16.327v79.674z",
    transform: "translate(260.356 8071)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 9575",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(640 8136)",
    style: {
      fill: "#f50"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesLogo3);
export default __webpack_public_path__ + "static/media/features-logo-3.e1502e88cc05d74e25bb885b826eb653.svg";
export { ForwardRef as ReactComponent };